import BreadCrumb from "Components/Common/BreadCrumb";
import "react-toastify/dist/ReactToastify.css";
import { Card, Container, Input } from "reactstrap";
import "./MarketingCampaign.scss";
import info from "../../assets/images/info.png";
import yellowAnimation from "../../assets/images/yellowAnimation.png";
import redAnimation from "../../assets/images/redAnimtion.png";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  getMarketingInvitationThunk,
  registerThunk,
} from "live-slices/Marketing-Campaign/thunk";
import { createSelector } from "reselect";
import index from "pages/Email/EmailTemplates/BasicAction";

const MarketingCampaign = () => {
  const selecteMarketingData = createSelector(
    (state: any) => state.Campaign,
    (campaignInvitation) => campaignInvitation?.campaignInvitation
  );
  const apiData = useSelector(selecteMarketingData);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    (dispatch as any)(getMarketingInvitationThunk());
    console.log(apiData);
  }, [dispatch]);

  const formatDate = (dateString: any) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    })
      .format(date)
      .replace(",", "");
  };

  const handleRegister = async (campaignId: any) => {
    try {
      await (dispatch as any)(registerThunk({ campaignId: campaignId }));
      // navigate(`/Campaign-Register/${campaignId}`);
    } catch (err) {
      // console.error("API failed:", err);
    }
  };

  return (
    <div className="page-content MarketingCampaignMainPage">
      <Container fluid>
        <BreadCrumb
          title="Campaign"
          pageTitle="Promotion"
          pageTitleRoute="/promotion"
        />
        <Card className="MarketingCampaignMainCard">
          <div className="headingInfo">
            <div className="d-flex align-items-center gap-2">
              <p>Campaign Invitation</p>
              <img src={info} alt="" />
            </div>
            <div className="d-flex gap-2">
              <Link to="/Campaign-Data">
                <button
                  className="CampaignButton"
                  data-testing-id="campaignDataButton_MarketingCampaign"
                >
                  Campaign Data
                </button>
              </Link>
              <Link to="/Submission-History">
                <button data-testing-id="submissionHistoryButton_MarketingCampaign">
                  Submission History
                </button>
              </Link>
            </div>
          </div>
          <div className="boxMain">
            {Array.isArray(apiData) && apiData.length > 0 ? (
              apiData.map((item: any) => (
                <div className="box" key={item._id}>
                  <div className="text">
                    <div>
                      <h1>{item.name}</h1>
                    </div>
                    <div className="date">
                      <div>
                        <p>Earliest Registration ends on</p>
                        <h6>
                          {formatDate(item?.timeline?.dealHuntingEndTime)}
                        </h6>
                      </div>
                      <div>
                        <p>Live Date</p>
                        <h6>
                          {formatDate(item.timeline.megaDurationStartTime)} -{" "}
                          {formatDate(item.timeline.megaDurationEndTime)}
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="Button">
                    <h3>{item.tier}</h3>
                    <Link to={`/Campaign-Register/${item._id}`}>
                      <button
                        data-testing-id={"registerNowButton_MarketingCampaign " + item._id}
                        onClick={() => handleRegister(item._id)}
                      >
                        Register Now
                      </button>
                    </Link>
                  </div>
                  <img src={yellowAnimation} className="yellowImg" alt="" />
                </div>
              ))
            ) : (
              <p>No data available</p>
            )}
          </div>
        </Card>
      </Container>
    </div>
  );
};

export default MarketingCampaign;
